import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import i18n from "src/i18n"
import { playerFacingError } from "src/utils/errorMessages"
import { addMessage } from "src/store/messages"

import userReducers from "../reducers"

/* Dropping the link. The server refuses when there is no password to fall back on, which is the
   one case where unlinking would lock the player out of their own games — the refusal arrives with
   its own sentence, so it is shown rather than translated into a shrug. */
export const thunk = createAsyncThunk("user/unlinkGoogle", async (_, { dispatch, rejectWithValue }) => {
  try {
    const response = await apiClient.delete("/auth/google/link/")
    dispatch(addMessage({ text: i18n.t("settings.googleUnlinked"), type: "info" }))
    return {
      googleLinked: response.data.google_linked,
      googleEmail: response.data.google_email ?? null,
      hasPassword: response.data.has_password,
    }
  } catch (error) {
    const detail = error.response?.data?.detail
    dispatch(addMessage({ text: detail || playerFacingError(error.response?.data), type: "error" }))
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = userReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
